class MessageEditor {
    #elem: HTMLElement | null | undefined;

    /**
     * コンストラクター。
     *
     * @param elem 対象の要素
     */
    constructor(elem: HTMLElement | null | undefined) {
        this.#elem = elem;
    }

    /**
     * `using`に対応するためのdispose処理。
     * なお、現在Safariで使えないため注意。
     */
    [Symbol.dispose]() {
        this.#elem = undefined;
    }

    /**
     * ブロッカー内のメッセージを編集する。
     * メッセージエリアが存在しない場合は何も起こらない。
     *
     * @param message メッセージ
     */
    editMessage(message: string) {
        if (this.#elem) {
            this.#elem.textContent = message;
        }
    }
}

let count = 0;

/**
 * ブロッカーを表示する。
 *
 * @param message 表示するメッセージ
 * @returns メッセージ操作クラス
 */
export const checkIn = (message?: string) => {
    if (count === 0) {
        document.body.classList.add("show-blocker");
        document.body.inert = true;
    }

    const elem = document.getElementById("blocker_message") as HTMLElement;
    if (elem) {
        elem.textContent = message ?? "";
    }

    count++;

    return new MessageEditor(elem);
};

/**
 * ブロッカーを消す。
 * 他にもブロッカー表示を要求されていた場合は、そちらの終了を待って消す。
 */
export const checkOut = () => {
    count--;

    if (count < 0) {
        console.warn(
            "'count' has a negative value.",
            "the number of calls to the 'checkIn' function does not match the number of calls to the 'checkOut' function.",
            "in most cases this is just a bug.");
        count = 0;
    }

    if (count === 0) {
        document.body.classList.remove("show-blocker");
        document.body.inert = false;
    }
};
